import React from 'react'
import block from 'bem-cn'
import { motion } from 'framer-motion'

import { IFiltersSlots } from 'modules/SlotsRoot/types/filters'

import SlotsLayoutContent from 'components/slots/SlotsLayoutContent'
import withQueryParams from './withQueryParams'

import './SlotsLayout.scss'

interface ISlotsLayoutProps {
  filters: IFiltersSlots
}

const b = block('slots-layout')

const SlotsLayout: React.FC<ISlotsLayoutProps> = props => (
  <motion.div
    animate={{ opacity: 1 }}
    initial={{ opacity: 0 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.15 }}
    className={b('wrapper')}>
    <SlotsLayoutContent {...props} />
  </motion.div>
)

export default withQueryParams(SlotsLayout)
